module.exports = __webpack_public_path__ + "static/ig-banner-horizontal-tablet-594506f0109c3176b74fb51cf0737994.jpg";